import { createIntl, createIntlCache } from '@formatjs/intl';

const cache = createIntlCache();

export let intl = createIntl(
  {
    locale: 'en',
    messages: {},
  },
  cache,
);

export function setIntl(locale, messages) {
  intl = createIntl(
    {
      locale,
      messages,
    },
    cache,
  );

  return intl;
}
